<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M52.552 11.448c.962.961 1.036 2.474.222 3.52l-.222.251-16.781 16.78 16.781 16.782c1.042 1.041 1.042 2.73 0 3.771-.961.962-2.474 1.036-3.52.222l-.251-.222L32 35.771 15.219 52.552c-1.041 1.042-2.73 1.042-3.771 0-.962-.961-1.036-2.474-.222-3.52l.222-.251L28.228 32l-16.78-16.781c-1.042-1.041-1.042-2.73 0-3.771.961-.962 2.474-1.036 3.52-.222l.251.222 16.78 16.78 16.782-16.78c1.041-1.042 2.73-1.042 3.771 0z" transform="translate(-210 -751) translate(210 751)"/>
            </g>
        </g>
    </g>
</svg>
